import { render } from "./EtiquetaCancelamento.vue?vue&type=template&id=08a50fde&scoped=true"
import script from "./EtiquetaCancelamento.vue?vue&type=script&lang=js"
export * from "./EtiquetaCancelamento.vue?vue&type=script&lang=js"

import "./EtiquetaCancelamento.vue?vue&type=style&index=0&id=08a50fde&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a50fde"]])

export default __exports__